import { Union, HTTP, map } from '../../lib'
import { Paginate } from '../../lib/types/Paginate'
import { update } from '../../lib/vuex'
import { oneTimeEarningsMap } from '../../utils/helper'
import httpClient, { financeHttpClient } from '../../api/httpClient'
import { sortBy } from 'lodash'
import { config } from '@/lib/helpers/config.helpers'

export const ToolbarState = Union('ToolbarState', {
  Idle: [],
  ShowSettings: [],
  ShowStats: [],
  ShowConvertLink: [],
  ShowAddTags: [],
  Pending: [],
})

export const DeepLinkStatus = Union('DeepLinkStatus', {
  Idle: [],
  Processing: [],
  Done: [],
  Failed: [],
})

export default {
  state: {
    ui: {
      filters: { query: '', storeGroup: '', client: '', userStatus: '' },
      users: {},
      status: HTTP.Request.Inactive(),
      pagination: Paginate.defaultState,
      tags: {
        suggestions: [],
        value: '',
        selected: [],
      },
    },
    storeGroups: [],
    clients: [],
    payments: [],
  },

  // todo need to remove all this mutations and leave only one 'update'
  mutations: {
    setFilter(state, { key, value }) {
      state.ui.filters[key] = value
    },

    setStatus(state, status) {
      state.ui.status = status
    },

    setDeepLinkStatus(state, { id, status }) {
      const { current } = state.ui.pagination
      state.ui.users[current] = map(state.ui.users[current], (user) => (user.id === id ? { ...user, deepLinkStatus: status } : user))
    },

    setCopied(state, { id, value }) {
      const { current } = state.ui.pagination
      state.ui.users[current] = map(state.ui.users[current], (user) => (user.id === id ? { ...user, deepLinkCopied: value } : user))
    },

    setToolbarState(state, { id, state: toolbarState }) {
      const { current } = state.ui.pagination
      state.ui.users[current] = map(state.ui.users[current], (user) => (user.id === id ? { ...user, toolbarState } : user))
    },

    setLink(state, { id, link }) {
      const { current } = state.ui.pagination
      state.ui.users[current] = map(state.ui.users[current], (user) => (user.id === id ? { ...user, link } : user))
    },

    setConvertedLink(state, { id, convertedLink }) {
      const { current } = state.ui.pagination
      state.ui.users[current] = map(state.ui.users[current], (user) =>
        user.id === id ? { ...user, convertedLink, deepLinkStatus: DeepLinkStatus.Done() } : user,
      )
    },

    update(state, { path, value }) {
      state.ui = update(state.ui, path, value)
    },

    setStoreGroups(state, value) {
      state.storeGroups = value
    },

    setClients(state, value) {
      state.clients = value
    },

    setPayments(state, value) {
      state.payments = value
    },
  },

  getters: {
    usersPerPage: ({
      ui: {
        users,
        pagination: { current },
      },
    }) => users[current] || [],
    status: ({ ui: { status } }) => status,
    filters: ({ ui: { filters } }) => filters,
    deepLinkCopied: ({ ui: { deepLinkCopied } }) => deepLinkCopied,
    pagination: ({ ui: { pagination } }) => pagination,
    tags: ({ ui: { tags } }) => tags,
    storeGroupsList: (state) => state.storeGroups,
    clientsList: (state) => state.clients,
    payments: (state) => state.payments,
  },

  actions: {
    showSettings({ commit }, user) {
      const commitType = user.userType === 'list' ? 'setToolbarState' : 'setToolbarStateUser'
      commit(commitType, {
        id: user.id,
        state: ToolbarState.ShowSettings(),
      })

      document.getElementById('app').classList.add('modal-open')

      $.event.trigger({
        type: 'metapic',
        startPage: 'newSettings',
        hideSidebar: true,
        baseUrl: config.creatorAppUrl,
        creatorId: user.id,
        lang: 'SV',
      })
      $(document).on('metapicClose', () => {
        document.getElementById('app').classList.remove('modal-open')
      })
    },

    showAddTags({ commit }, user) {
      commit('update', { path: 'tags.value', value: '' })
      if (user.userType === 'list') {
        commit('setToolbarState', {
          id: user.id,
          state: ToolbarState.ShowAddTags(),
        })
      } else if (user.userType === 'single') {
        commit('setToolbarStateUser', {
          state: ToolbarState.ShowAddTags(),
        })
      }
    },

    showConvertLink({ commit }, user) {
      const commitType = user.userType === 'list' ? 'setToolbarState' : 'setToolbarStateUser'
      commit(commitType, {
        id: user.id,
        state: ToolbarState.ShowConvertLink(),
      })
    },

    showStats({ commit }, user) {
      commit('setToolbarState', {
        id: user.id,
        state: ToolbarState.ShowStats(),
      })

      document.getElementById('app').classList.add('modal-open')

      $.event.trigger({
        type: 'metapic',
        startPage: 'stats',
        hideSidebar: true,
        baseUrl: config.apiBaseUrl,
        creatorId: user.id,
      })
      $(document).on('metapicClose', () => {
        document.getElementById('app').classList.remove('modal-open')
      })
    },

    showNewStats({ commit }, user) {
      const commitType = user.userType === 'list' ? 'setToolbarState' : 'setToolbarStateUser'
      commit(commitType, {
        id: user.id,
        state: ToolbarState.ShowStats(),
      })

      document.getElementById('app').classList.add('modal-open')

      $.event.trigger({
        type: 'metapic',
        startPage: 'newStats',
        hideSidebar: true,
        baseUrl: config.creatorAppUrl,
        creatorId: user.id,
      })
      $(document).on('metapicClose', () => {
        document.getElementById('app').classList.remove('modal-open')
      })
    },

    showStoreListing({ commit }, user) {
      const commitType = user.userType === 'list' ? 'setToolbarState' : 'setToolbarStateUser'
      commit(commitType, {
        id: user.id,
        state: ToolbarState.ShowStats(),
      })

      document.getElementById('app').classList.add('modal-open')

      $.event.trigger({
        type: 'metapic',
        startPage: 'newStores',
        hideSidebar: true,
        baseUrl: config.creatorAppUrl,
        creatorId: user.id,
      })
      $(document).on('metapicClose', () => {
        document.getElementById('app').classList.remove('modal-open')
      })
    },

    convertLink({ commit }, user) {
      if (!user.link) return
      let commitType = user.userType === 'list' ? 'setDeepLinkStatus' : 'setDeepLinkStatusUser'
      commit(commitType, {
        id: user.id,
        status: DeepLinkStatus.Processing(),
      })

      httpClient
        .post(`${config.apiBaseUrl}/v3/users/${user.id}/affiliate-links`, { url: user.link })
        .then((response) => {
          commitType = user.userType === 'list' ? 'setConvertedLink' : 'setConvertedLinkUser'
          commit(commitType, {
            id: user.id,
            convertedLink: response.data.mtpc_url,
          })
        })
        .catch(() => {
          commit(commitType, {
            id: user.id,
            status: DeepLinkStatus.Failed(),
          })
        })
    },

    setLink({ commit }, { id, link, userType }) {
      const commitType = userType === 'list' ? 'setLink' : 'setLinkUser'
      commit(commitType, { id, link })
    },

    setCopied({ commit }, user) {
      const commitType = user.userType === 'list' ? 'setCopied' : 'setCopiedUser'
      commit(commitType, { id: user.id, value: true })
      setTimeout(() => commit(commitType, { id: user.id, value: false }), 1000)
    },

    fetchUsers({ commit, state }, page = 1) {
      commit('update', { path: 'status', value: HTTP.Request.Pending() })
      const params = {
        ...state.ui.filters,
        page,
      }
      const { pagination } = state.ui

      const url = '/users/find'
      Paginate.setCurrentPage({ pagination, page, commit, url, params })
        .then((response) => {
          if (response) {
            const { data, current_page } = response.data
            const userData = data.map((user) => ({
              ...user,
              link: '',
              convertedLink: '',
              toolbarState: ToolbarState.Idle(),
              deepLinkStatus: DeepLinkStatus.Idle(),
              userType: 'list',
              deepLinkCopied: false,
              one_time_earnings: oneTimeEarningsMap(user.one_time_earnings),
            }))
            let value = { [current_page]: userData }
            if (current_page !== 1) {
              value = { ...state.ui.users, ...value }
            }
            commit('update', { path: 'users', value })
          }
          commit('update', { path: 'status', value: HTTP.Request.Done() })
        })
        .catch((error) => {
          console.error("Couldn't fetch users, ", error)
          commit('update', { path: 'status', value: HTTP.Request.Failed() })
        })
    },

    addUserTag({ dispatch }, tag) {
      if (
        tag.user.user_tags.some((item) => {
          return item.id != null ? item.id === tag.value.id : item.name === tag.value.name
        }) === false &&
        tag.value.name !== ''
      ) {
        tag.user.user_tags.push(tag.value)
        dispatch('saveUserTags', { user: tag.user, userType: tag.user.userType })
      }
    },

    removeUserTag({ dispatch }, tag) {
      tag.user.user_tags = tag.user.user_tags.filter((item) => {
        return item.id != null ? item.id !== tag.value.id : item.name !== tag.value.name
      })
      dispatch('saveUserTags', { user: tag.user, userType: tag.user.userType })
    },

    getTags({ commit }) {
      httpClient
        .get(`/admin/user-tags`)
        .then((response) => {
          commit('update', { path: 'tags.suggestions', value: response.data })
        })
        .catch((error) => console.log(error))
    },
    getPayments({ commit }, userId) {
      financeHttpClient
        .get(`/payments?creator_id=${userId}&limit=100`)
        .then((response) => {
          commit('setPayments', response.data.items)
        })
        .catch((error) => console.log(error))
    },
    saveUserTags({ commit }, { user, userType }) {
      const commitType = userType === 'list' ? 'setToolbarState' : 'setToolbarStateUser'
      const currentToolbarState = user.toolbarState
      commit(commitType, { id: user.id, state: ToolbarState.Pending() })

      httpClient
        .post('/admin/user-tags/' + user.id, {
          tags: user.user_tags.map((tag) => tag.name),
        })
        .then(() => {
          commit(commitType, { id: user.id, state: currentToolbarState })
        })
        .catch((error) => console.log(error))
    },
    async fetchStoreGroups({ commit }) {
      try {
        const { data } = await httpClient.get(`/storeGroups`)
        const storeGroups = sortBy(
          data.map((storeGroup) => ({
            id: storeGroup.id,
            label: storeGroup.name,
            value: storeGroup.id,
          })),
          (item) => item.label.toLowerCase(),
        )
        commit('setStoreGroups', storeGroups)
      } catch (error) {
        console.error(error)
      }
    },
    async fetchClients({ commit }) {
      try {
        const { data } = await httpClient.get(`/clients-list`)
        const clients = sortBy(
          data.map((client) => ({
            id: client.id,
            label: client.name || `id: ${client.id}`,
            value: client.id,
          })),
          (item) => item.label.toLowerCase(),
        )
        commit('setClients', clients)
      } catch (error) {
        console.error(error)
      }
    },
  },
}
